module.exports = __webpack_public_path__ + "img/wrists.26cd74c1.png";